import { NotificationTypeDto } from '@/api/generated';
import { NotificationsDictionariesTranslation } from '@/assets/locales/dictionaries/notifications/notifications.dictionaries.pl.ts';

export const notificationsDictionariesTranslation: NotificationsDictionariesTranslation = {
  [NotificationTypeDto.DevelopmentPlanInitialized]: 'Plan initialized',
  [NotificationTypeDto.DevelopmentPlanSupervisorAccepted]: 'Accepted by supervisor',
  [NotificationTypeDto.DevelopmentPlanSupervisorRejected]: 'Rejected by supervisor',
  [NotificationTypeDto.DevelopmentPlanToSupervisorAcceptanceRequested]:
    'Pending Supervisor approval',
  [NotificationTypeDto.DevelopmentPlanRequired]: 'Development plan required',
  [NotificationTypeDto.DevelopmentPlanInitiationRequired]: 'Initiate subordinate development plan',
  [NotificationTypeDto.DevelopmentStepOverdue]: 'Development step overdue',
  [NotificationTypeDto.EmployeeBirthdayAfter]: 'Employee recently had a birthday',
  [NotificationTypeDto.EmployeeBirthdayToday]: "Employee's birthday is today",
  [NotificationTypeDto.EmployeeBirthdayUpcoming]: 'Upcoming employee birthday',
  [NotificationTypeDto.ExamDayStarted]: 'Test slot is starting',
  [NotificationTypeDto.ExamParticipantAdded]: 'Added to test slot',
  [NotificationTypeDto.IndividualExamStarted]: 'Your exam is starting',
  [NotificationTypeDto.SurveyAssigned]: 'Survey assigned',
};
